import { SeoRenderer } from "../../../common/helpers/seo";

import image from "./image";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["article.covid.title"],
            description: allMessage["article.covid.p1"],
            allMessage,
            lang,
            image,
        });
    },
};
